import { connect } from 'react-redux'

import { Pagination } from '@bikemap/components/Pagination'
import { updatePage } from './actions'
import { addressReducer } from '../../utility/state'

const mapStateToProps = (state, { listKey }) => {
    const { page, count, pageSize } = state[listKey]
    return {
        page: page,
        numPages: Math.ceil(count / pageSize),
    }
}

const mapDispatchToProps = (dispatch, { listKey }) => ({
    onChange: page => dispatch(addressReducer(listKey, updatePage(page))),
})

/**
 * A pagination connected to the given list reducer.
 * @param {Object} props
 * @param {string} props.listKey Key of the list reducer in the global state
 */
export default connect(mapStateToProps, mapDispatchToProps)(Pagination)
